import React from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import {
  StyedInputFieldWrapper,
  StyledAdminLoginFormInput,
  StyledAdminLoginFormLabel,
  StyledAuthPasswordVisibilityToggle,
} from '@/components/ui/InputField/InputFieldGroup.styled.ts';
import PasswordVisibleIcon from '@/components/icons/PasswordVisibilityIcon/PasswordVisibleIcon';
import PasswordInvisibleIcon from '@/components/icons/PasswordVisibilityIcon/PasswordInvisibleIcon';

type Props = {
  label: string;
  register: UseFormRegisterReturn;
  placeholder: string;
  error?: string;
  onFocus?: () => void;
} & (NonPasswordInputProp | PasswordInputProp);

type NonPasswordInputProp = {
  isPassword: false;
};
type PasswordInputProp = {
  isPassword: true;
  isPasswordVisible: boolean;
  passwordVisibilityDispatcher: (value: React.SetStateAction<boolean>) => void;
};

const AuthInputField: React.FunctionComponent<Props> = (props) => {
  return (
    <>
      <StyledAdminLoginFormLabel>{props.label}</StyledAdminLoginFormLabel>
      {!props.isPassword ? (
        <StyledAdminLoginFormInput
          placeholder={props.placeholder}
          {...props.register}
          $error={!!props.error}
        />
      ) : (
        <StyedInputFieldWrapper>
          <StyledAdminLoginFormInput
            placeholder={props.placeholder}
            {...props.register}
            type={props.isPasswordVisible ? 'text' : 'password'}
            $error={!!props.error}
          />
          <StyledAuthPasswordVisibilityToggle
            onClick={() => props.passwordVisibilityDispatcher((val) => !val)}
          >
            {props.isPasswordVisible ? <PasswordVisibleIcon /> : <PasswordInvisibleIcon />}
          </StyledAuthPasswordVisibilityToggle>
        </StyedInputFieldWrapper>
      )}
    </>
  );
};

export default AuthInputField;
